import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ConceptsSection } from '../components/ConceptsSection';
import { InvestmentSection } from '../components/InvestmentSection';
import { MembershipsSection } from '../components/MembershipsSection';
import { PressSection } from '../components/PressSection';
import { Marquee } from '../components/Marquee';
export function HomePage() {
  return <>
      <HeroSection data-id="element-747" />
      <Marquee text="RESTAURANTS • PRIVATE DINING • CATERING • EVENTS • HOSPITALITY" bgColor="bg-brand-red" data-id="element-748" />
      <AboutSection data-id="element-749" />
      <ConceptsSection data-id="element-750" />
      <Marquee text="INVESTMENT • REAL ESTATE • MANAGEMENT • GROWTH • EXCELLENCE" bgColor="bg-brand-terracotta" data-id="element-751" />
      <InvestmentSection data-id="element-752" />
      <MembershipsSection data-id="element-753" />
      <PressSection data-id="element-754" />
    </>;
}